// extracted by mini-css-extract-plugin
export var CompanyMenuLogo = "Header-module--CompanyMenuLogo--675b0";
export var HeaderBtnSection = "Header-module--HeaderBtnSection--dc592";
export var HideHeader = "Header-module--HideHeader--7ff6f";
export var HomeLinkNav = "Header-module--HomeLinkNav--ba3d3";
export var MenuActive = "Header-module--MenuActive--0a669";
export var MenuContainer = "Header-module--MenuContainer--89e30";
export var MenuOpen = "Header-module--MenuOpen--59e69";
export var NavVisited = "Header-module--NavVisited--94b32";
export var SocialMediaLinks = "Header-module--SocialMediaLinks--df286";
export var copyrights = "Header-module--copyrights--118b9";
export var dot = "Header-module--dot--52d28";
export var dotWrap = "Header-module--dotWrap--306ff";
export var headerConnectBtn = "Header-module--headerConnectBtn--14f6d";
export var headerContainer = "Header-module--headerContainer--69d29";
export var headerWrapper = "Header-module--headerWrapper--b4bef";
export var hiddenActive = "Header-module--hiddenActive--e885d";
export var hover = "Header-module--hover--3decd";
export var logo = "Header-module--logo--79f8a";
export var mobileMenuRules = "Header-module--mobileMenuRules--1d86f";
export var mobileMenuWrap = "Header-module--mobileMenuWrap--f6837";
export var navMenuLinks = "Header-module--navMenuLinks--2999d";
export var navbar = "Header-module--navbar--89582";
export var pageLink = "Header-module--pageLink--3bbb2";
export var policyTerms = "Header-module--policyTerms--6cb75";
export var rightSection = "Header-module--rightSection--f03ac";